
import {
  GET_DEVELOPMENT_PANNEL_STATUS, GET_DEVELOPMENT_INFO, UPDATE_MINPROGRAM_ID, UPDATE_REGDEVELOPMENT_LOADING,
  GET_PROGRAM_PANNEL_INFO, DEVELOPMENT_MODEL_STATUS, GET_IS_DEVELOPMENT, UPDATE_ACCOUNT_LIST, UPDATA_GREY_PUBLIC_MODEL_STATUS,
  UPDATA_PUBLIC_MODEL_STATUS, GET_PUBLIC_APP_LIST, UPDATE_SELECTED_PUBLIC_APP_LIST, GET_PACK_STATUS, QUERY_PUBLISH_TIME,
  UPDATE_LOADING_STATUS
} from "../actions/appDevelopPannel";

const defVal = {
  loading: true,
  developmentInfo: {},
  regDevelopmentLoading: false,
  minprogramId: '',
  developmentPannlStatus: false,
  isDevelopmentStatus: false,
  developModelStatus: false,
  programPannelInfo: {},
  accountList: [], //面板测试账号
  greyPublicModelVisible: false, // 灰度发布弹窗
  publicAppModalVisible: false, // 全量发布弹窗
  publicAppList: [], // 发布app列表
  publicSelectedAppList: [], // 发布已选择的app列表
  packStatus: 1, //当前打包状态
  publishTime: null, //发布时间
};

export default (state = defVal, action) => {
  switch (action.type) {
    case UPDATE_LOADING_STATUS:
      return Object.assign({}, state, {
        loading: action.loading
      });
    case GET_DEVELOPMENT_PANNEL_STATUS:
      return Object.assign({}, state, {
        developmentPannlStatus: action.developmentPannlStatus
      });
    case GET_IS_DEVELOPMENT:
      return Object.assign({}, state, {
        isDevelopmentStatus: action.isDevelopmentStatus
      });
    case GET_DEVELOPMENT_INFO:
      return Object.assign({}, state, {
        developmentInfo: action.developmentInfo
      });
    case UPDATE_REGDEVELOPMENT_LOADING:
      return Object.assign({}, state, {
        regDevelopmentLoading: action.regDevelopmentLoading
      });
    case UPDATE_MINPROGRAM_ID:
      return Object.assign({}, state, {
        minprogramId: action.minprogramId
      });
    case GET_PROGRAM_PANNEL_INFO:
      return Object.assign({}, state, {
        programPannelInfo: action.programPannelInfo
      });
    case DEVELOPMENT_MODEL_STATUS:
      return Object.assign({}, state, {
        developModelStatus: action.developModelStatus
      });
    case UPDATE_ACCOUNT_LIST:
      return Object.assign({}, state, {
        accountList: action.accountList
      });
    case UPDATA_GREY_PUBLIC_MODEL_STATUS:
      return Object.assign({}, state, {
        greyPublicModelVisible: action.greyPublicModelVisible
      });
    case UPDATA_PUBLIC_MODEL_STATUS:
      return Object.assign({}, state, {
        publicAppModalVisible: action.publicAppModalVisible
      });
    case GET_PUBLIC_APP_LIST:
      return Object.assign([], state, {
        publicAppList: action.publicAppList
      });
    case UPDATE_SELECTED_PUBLIC_APP_LIST:
      return Object.assign([], state, {
        publicSelectedAppList: action.publicSelectedAppList
      });
    case GET_PACK_STATUS:
      return Object.assign([], state, {
        packStatus: action.packStatus
      });
    case QUERY_PUBLISH_TIME:
      return Object.assign([], state, {
        publishTime: action.publishTime
      });
    default:
      return state;
  }
};
